import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';
import { getSecuredPages } from 'redux/actions/pagesActions';
import { updateAuthTokenAction } from 'redux/actions/authActions';
import { Theme } from 'utils/Theme';
import classnames from 'classnames';
import Footer from 'components/layout/Partials/Footer';
import SidebarMenuContainer from 'components/layout/Partials/SidebarMenuContainer';

const styles = Theme();

class AdminLayout extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pages: null,
            loading: true,
            currentPage: this.props.currentPage,
            showMenu: window.innerWidth > 1000,
        };

        this.handleResize = this.handleResize.bind(this);
    }

    componentDidMount() {
        window.addEventListener('resize', this.handleResize);
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        let { pages } = prevState;
        const { auth } = nextProps;

        if (!auth.isAuthenticated) {
            return nextProps.history.push('/login');
        }
        return { pages };
    }

    handleResize(e) {
        this.setState({ showMenu: window.innerWidth > 1000 });
    }

    render() {
        return (
            <div className={classnames('o-page')}>
                <SidebarMenuContainer />
                <main
                    className={classnames('o-page__content', {
                        ' menu-hide': !this.props.sidebarVisibility,
                    })}
                >
                    {this.props.children}
                    <Footer />
                </main>
            </div>
        );
    }
}

AdminLayout.propTypes = {
    auth: PropTypes.object.isRequired,
    updateAuthTokenAction: PropTypes.func,
    getSecuredPages: PropTypes.func,
    currentPage: PropTypes.string,
    history: PropTypes.object,
    pages: PropTypes.array,
    match: PropTypes.object,
    loading: PropTypes.bool,
    children: PropTypes.any,
};

const mapStateToProps = (state) => ({
    auth: state.auth,
    pages: state.pages.pages,
    loading: state.pages.loading,
    sidebarVisibility: state.theme.sidebarVisibility,
});

export default connect(mapStateToProps, {
    getSecuredPages,
    updateAuthTokenAction,
})(withRouter(withStyles(styles)(AdminLayout)));
